const options = {
  page: {
    title: 'Bring your ideas to life',
    titleColor: '#fff',
    subtitle: 'We work to enhance the quality of life of our customers by providing high-valued products and services.',
    subtitleColor: '#fff',
    contentBeforeData: '',
    contentAfterData: '',
    contentBeforeDataMd: '',
    contentAfterDataMd: ''
  },
  header: {
    headerLayout: 'logo-left', // logo-left, logo-right, logo-center
    headerStyle: 'solid', // solid, transparent
    headerLogoImage: '',
    headerTagline: '',
    headerLogoExternalURL: {
      enabled: false,
      link: ''
    },
    showHeader: false,
    headerTextColor: '',
    headerButtonsColor: '',
    sideBarMenuByDefault: false,
    stickyHeader: false,
    mobileBottomNavigationEnabled: false,
    mobileBottomNavigationItems: []
  },
  footer: {
    showFooter: false,
    footerText: '',
    showSocialNetworks: false
  },
  appearance: {
    theme: { value: 'is-light', class: 'sv-is-light', label: 'Light Theme' },
    bgColor: '',
    logoImage: '',
    coverImage: 'https://images.unsplash.com/photo-1543857778-c4a1a3e0b2eb?ixlib=rb-1.2.1&q=80&fm=jpg&crop=entropy&cs=tinysrgb&w=1080&fit=max&ixid=eyJhcHBfaWQiOjEwOTg0MH0',
    coverLayout: 'is-fixedheight',
    introKeepAspectRatio: false,
    showHomeIntro: true,
    openFiltersOnMobileByDefault: false,
    stickyFilters: false,
    scrollToTopBtn: false,
    globalFonts: {
      headingFont: '',
      bodyTextFont: ''
    }
  },
  viewer: {
    tileOptions: {
      title: {
        id: null
      },
      cardStyle: {
        value: 'tile' // tile | list
      },
      tilesSize: {
        type: 'large' // large | small
      },
      isTableScrollable: false,
      subtitle: {
        id: null
      },
      price: {
        id: null
      },
      oldPrice: {
        id: null
      },
      content: {
        id: null
      },
      image: {
        ids: [],
        keepAspectRatio: false,
        lightboxEnabled: false
      },
      specs: {
        ids: [],
        label: 'Properties'
      },
      badges: {
        ids: [],
        label: 'Badge'
      },
      sku: {
        id: null
      },
      cta: {
        id: null,
        title: '',
        type: '',
        color: '#51535d',
        enabled: true,
        style: 'is-primary', // is-primary, is-secondary
        showQuantityPicker: false
      },
      cta_second: {
        id: null,
        title: '',
        type: '',
        color: '#51535d',
        enabled: false,
        style: 'is-secondary', // is-primary, is-secondary
        showQuantityPicker: false
      },
      doNotStretchContent: false
    },
    mapView: {
      enabled: false,
      markerColId: null,
      mapType: 'osm',
      markerType: 'pin',
      useClusters: false,
      markerImageColId: '',
      mapHeight: 640,
      zoom: 3,
      mapCenter: '0, 0',
      defaultView: 'mapView'
    },
    calendarView: {
      enabled: false,
      startDateColId: null,
      weekStartsOn: 'monday' // 'monday' | 'sunday'
    },
    enableSingleItemView: false,
    showSingleItemAsPopup: true,
    favorites: {
      enabled: false
    },
    singleItemOptions: {
      url: {
        id: null
      },
      title: {
        id: null
      },
      subtitle: {
        id: null
      },
      price: {
        id: null
      },
      oldPrice: {
        id: null
      },
      status: {
        id: null
      },
      content: {
        id: null
      },
      image: {
        ids: [],
        keepAspectRatio: false,
        lightboxEnabled: false
      },
      specs: {
        ids: []
      },
      badges: {
        ids: []
      },
      cta: {
        id: null,
        title: '',
        type: '',
        color: '#51535d',
        enabled: true,
        style: 'is-primary', // is-primary, is-secondary
        showQuantityPicker: false
      },
      cta_second: {
        id: null,
        title: '',
        type: '',
        color: '#51535d',
        enabled: false,
        style: 'is-secondary', // is-primary, is-secondary
        showQuantityPicker: false
      },
      baseRoute: 'item',
      mapView: {
        enabled: false,
        mapType: 'osm',
        markerColId: null,
        markerType: 'pin',
        markerImageColId: '',
        mapHeight: 640,
        zoom: 3
      },
      layout: {
        reverse: false,
        type: 'content-on-side' // 'full-width', 'content-split'
      },
      socialShareButtons: {
        enabled: false,
        style: 'popup',
        popupTitleText: 'Share this link!',
        buttons: [
          'twitter',
          'facebook',
          'whatsapp',
          'linkedin',
          'reddit',
          'viber',
          'pinterest',
          'telegram',
          'messenger',
          'email'
        ]
      },
      relatedItems: {
        enabled: false,
        sectionTitle: '',
        itemsStyle: 'tile', // tile | list | horizontal
        itemsSize: 'small', // small | large
        isTableScrollable: false,
        maxCount: 3,
        selectionMethod: 'random', // random | category | sku
        categoryColumn: {
          id: null
        },
        skuColumn: {
          id: null
        }
      }
    }
  },
  search: {
    enabled: true,
    searchByColumns: [],
    placeholder: '',
    introSearch: {
      enabled: false,
      emptyStateText: '',
      resultsLimit: 8
    }
  },
  filters: {
    enabled: false,
    asideFiltersView: false,
    asideFiltersCollapsedByDefault: false,
    values: [],
    blockUnavailableOptions: false
  },
  sorting: {
    enabled: false,
    asideSortingView: false,
    asideSortingCollapsedByDefault: false,
    shuffleRows: false,
    reverseDefaultOrder: false,
    directions: [
      { value: 'desc', label: 'DESC' },
      { value: 'asc', label: 'ASC' }
    ],
    ids: [],
    default: {
      id: 'INDEX',
      direction: 'asc'
    }
  },
  pagination: {
    enabled: true,
    itemsPerPage: 40
  },
  variants: {
    enabled: false,
    variantsGroupBy: {
      id: null,
      groupCards: true
    },
    variantsOptions: {
      ids: [],
      showVariantsOptionsInCards: false
    }
  },
  stock: {
    enabled: false,
    id: null,
    outOfStockLabel: 'Out of stock',
    outOfStockLink: ''
  },
  contact: {
    email: ''
  },
  scripts: {
    scriptInHead: '',
    scriptInBodyStart: '',
    scriptInBodyFinish: ''
  },
  autoMapping: {
    requiresAutoMapping: true
  },
  seo: {
    favIcon: '',
    metaTitle: '',
    metaDescription: '',
    metaKeywords: '',
    ogImage: ''
  },
  cart: {
    cartView: 'popup',
    onAddToCart: 'openCheckout',
    showCartPreview: false,
    сartPreviewSettings: {
      title: '',
      submitButtonText: '',
      backButtonText: ''
    },
    cartFormTitle: '',
    cart_title: '',
    cart_button_text: '',
    cart_tm_title: '',
    cart_tm_text: '',
    cart_details_message: '',
    cart_continue_text: '',
    cartItemsAmountLimit: false,
    cartItemQuantityLimit: false,
    cartCopyLink: false
  },
  locale: 'en',
  webhooks: {
    sendOrder: ''
  },
  emailOptions: {
    notificationsEmailEnabled: true,
    notificationsEmailTo: '',
    notificationsEmailFrom: 'notify@alerts.spreadsimple.com',
    notificationsEmailSenderName: '',
    notificationsEmailSubject: 'Your order from SpreadSimple: {{orderId}}',
    notificationsEmailTemplate: `## You have a new order

Order #:  **{{orderId}}**
___
**Order information**
{{clientDetailsText}}
___
**Items ordered**
{{cartItemsText}}
___
**Taxes & fees:**  {{taxItemsText}}
**Tips:** {{tipItemText}}
**Shipping method:**  {{shippingMethodText}}
**Payment method:**  {{paymentMethod}}

## Total: {{totalAmountFormatted}}
`,

    receiptEmailEnabled: false,
    receiptEmailFrom: 'notify@alerts.spreadsimple.com',
    receiptReplyToEmail: '',
    receiptEmailSubject: 'Your order from SpreadSimple: {{orderId}}',
    receiptSenderName: '',
    receiptEmailTemplate: `## Thanks for your order

Order #: {{orderId}}

#### Items Ordered

{{cartItemsText}}

Total: {{totalAmountFormatted}}

Name: {{client.name}}
Phone: {{client.phone}}
Email: {{client.email}}

Order notes: {{client.message}}`,
    websiteAccess: {
      fromName: '',
      subject: '{{websiteDomain}} request code',
      body: `Hello! Someone has requested code for your email to access {{websiteDomain}}

Follow {{loginUrl}} to log in with this magic link.

Or copy your code:
# {{validationCode}}`
    },
    websiteAccessRegistration: {
      emailTemplates: {
        registrationVerification: {
          subject: 'Complete your signup on {{websiteDomain}} – verify your email',
          body: `Hi there, 
Thanks for signing up with {{websiteDomain}}!
To finish setting up your account, please use the verification code: 
# {{validationCode}}
This code will expire in 1 hour, so be sure to enter it soon.
If you didn’t request this code or believe this was a mistake, feel free to ignore this email.`        
        },
        userRegistrationNotice: {
          subject: 'Email confirmed – you are almost there!',
          body: `You have successfully verified your email — you're one step closer to getting started.
Access to the site is pending approval from the site owner. 
Thank you for your patience!`
        },
        ownerRegistrationNotice: {
          subject: 'New User Signup on {{websiteDomain}}',
          body: `A new user, {{userEmail}}, has signed up on your website {{websiteDomain}}.
Please review and update their user access group in your User Google Sheet.`
        }
      }
    }
  },
  paypal: {
    enablePaypalCheckout: false,
    currency: 'USD',
    environment: 'sandbox',
    sandboxClientId: '',
    productionClientId: '',
    buttonColor: 'blue'
  },
  routes: [],
  checkout: {
    fields: [],
    shipping: [],
    fees: [],
    tipsTitle: 'Tips',
    tips: [],
    paymentsOrder: [],
    promocodes: {
      enabled: false
    }
  },
  widget: {
    onlyWidgetMode: false,
    widgetModeDisallowed: false,
    allowedDomains: []
  },
  redirectRules: [],
  privateData: {
    privateCells: {
      enabled: false,
      ids: []
    },
    privateRow: {
      enabled: false,
      id: null
    }
  },
  loginPage: {
    markdown: `## Welcome!

Please provide your email address.
We will send you the validation code that you will need to log in.`
  },
  signupPage: {
    redirectLink: '/signup-success',
    markdown: `## Sign up to get started

Enter your email, first name, and last name.
We’ll send you a verification code to complete your sign-up.`
  },
  socialNetworks: [],
  redirectToCustomDomain: false,
  otherStates: {
    custom404forEmptyList: {
      markdown: ''
    },
    custom404forNoDetailsPage: {
      markdown: ''
    }
  }
}

export default options

// .class
// .meta-title
// .meta-description
// .og-image
// .date
